"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserIdCaptureComponentParameters = void 0;
exports.UserIdCaptureComponentParameters = [
    {
        id: 'idType',
        label: 'ID Type',
        description: 'Input Param - Specifies the type of ID to be captured (e.g., email, username).',
        type: 'string',
        paramType: 'STRING',
        required: true,
    },
    {
        id: 'checkUniqueness',
        label: 'Check Uniqueness',
        description: 'Input Param - Boolean indicating whether the captured ID must be unique.',
        type: 'boolean',
        paramType: 'BOOLEAN',
        required: false,
    },
    {
        id: 'userIdData',
        label: 'User ID Data',
        description: 'Output Param - Captures the user ID data.',
        type: 'output',
        paramType: 'ARRAY',
        required: true,
    },
];
//# sourceMappingURL=UserIdCaptureComponent.js.map